// client/src/api/ApiPlayers.js
import flex from './FlexFetch'
import { unwrapListPayload, unwrapStrictPayload } from './listPayloadUtils'

const player_endpoint = '/api/1.0/players/'

async function getAll() {
  const response = await flex.flexFetch(player_endpoint + 'all')
  const payload = await flex.handleResponse(response)
  return unwrapListPayload(payload)
}

async function create(player) {
  const response = await flex.flexFetch(player_endpoint + 'create', {
    method: 'POST',
    body: JSON.stringify(player),
  })
  const payload = await flex.handleResponse(response)
  return unwrapStrictPayload(payload)
}

async function update(player) {
  const response = await flex.flexFetch(player_endpoint + 'update', {
    method: 'PUT',
    body: JSON.stringify(player),
  })
  const payload = await flex.handleResponse(response)
  return unwrapStrictPayload(payload)
}

async function remove(id) {
  const response = await flex.flexFetch(
    player_endpoint + `delete?player_id=${id}`,
    {
      method: 'DELETE',
    },
  )
  const payload = await flex.handleResponse(response)
  const data = unwrapStrictPayload(payload)
  return data?.deleted === true ? 'deleted the player from the database' : data
}

async function getMyPlayers() {
  const response = await flex.flexFetch('/api/1.0/players/getMyPlayers', {
    credentials: 'include',
  })
  const payload = await flex.handleResponse(response)
  return unwrapListPayload(payload)
}

async function getById(id) {
  const response = await flex.flexFetch(`/api/1.0/players/get?id=${id}`)
  const payload = await flex.handleResponse(response)
  return unwrapStrictPayload(payload)
}

async function getHistory(playerId) {
  const response = await flex.flexFetch(
    `/api/1.0/players/history?player_id=${playerId}`,
  )
  const payload = await flex.handleResponse(response)
  return unwrapStrictPayload(payload)
}

const ApiPlayers = {
  getAll,
  create,
  remove,
  update,
  getMyPlayers,
  getById,
  getHistory,
}

export default ApiPlayers
